import { BaseBus } from './BaseBus';
import { DateFunctions } from '../static/date-functions';
/*
 * Part #: inventoryNumber
 * Description: inventoryDesc
 * Rcvd : totalReceived
 * Ratio: ratio
 * Qty: quantity
 * Used Qty: usedPartQuantity
 * Supplier: supplierName
 * Qty Billed: [NEED-FIX]
 * Go To Order: orderNumber
 * Price: price
 * Amount: amount 
 * $ Check: [NEED-FIX]// Pulls up detail form
 * Intended Warehouse: [NEED-FIX] // have warehouseId
 * Acknowldeged: [NEED-FIX]
 * Wrong part: isWrongPart
 * Replace: [NEED-FIX]
 * To Be Returned: toBeReturned
 * 
 * 
 */
export class v_DispatchPartsOrderedBus extends BaseBus
{
    constructor(busObj: v_DispatchPartsOrderedBus = null) {
        super(busObj);
        this.updatedt = DateFunctions.getDate(this.updatedt);
        this.sageDt = DateFunctions.getDate(this.sageDt);
    }
    CID(): any {
        return this.orderDetailId;
    }

    get inFinance(): boolean {
        return DateFunctions.isValidDate(this.sageDt);
    }

  orderDetailId: any;
  orderId: any;
  inventoryId: any;
  dispatchId: any;
  quantity: number;
  price: number;
  amount: number;
  inventoryDesc: string;
  inventoryNumber: string;
  dispatchNumber: string;
  orderReceiveDetailId: any;
  inventoryLocationId: any;
  quantityReceived: number;
  totalReceived: number;
  quantityBilled: number;
  accountClassId: any;
  orderNumber: string;
  updatedt: Date;
  supplierName: string;
  isWrongPart: boolean;
  viewedInMobile: boolean;
  toBeReturned: boolean;
  manufacturerNumber: string;
  currentCost: number;
  lastCost: number;
  flatCost: number;
  ratio: number;
  internationalCost: number;
  avgCost: number;
  isPart: boolean;
  fullDescription: string;
    warehouseId: any;
    warehouse:string
  usedPartQuantity: number;
  onConstDraw: boolean;
  supplierId: any;
  isSubContract: boolean;
  pmApprovalId: any;
  sageDt: Date;
  dummy: any;
  acknowledge: boolean;
    replace: boolean;
    refNbr: string
}
